import Vue from 'vue'
import VueRouter from 'vue-router'
// import login from '@/views/login/login1'
import login from '@/views/login/login3'
import index from '@/views/index/index'
import register from '@/views/register/register'
import teacherRegister from '@/views/teacherRegister/teacherRegister'
import center from '@/views/center/center'
import profile from '@/views/center/profile'
import study from '@/views/center/study'
import watch from '@/views/center/watch'
import note from '@/views/center/note'
import clock from '@/views/center/clock'
import tasks from '@/views/center/tasks'
import messages from '@/views/center/messages'
import videoList from '@/views/videoList/videoList'
import videoPlay from '@/views/videoPlay/videoPlay'
import publicVideo from '@/views/publicTask/publicVideo'
import departmentVideo from '@/views/department/departmentVideo'
import training from '@/views/training/training'
import trainingMaterials from '@/views/training/trainingMaterials'
import trainingPlanGuide from '@/views/training/trainingPlanGuide'
import activityVideo from '@/views/activity/activityVideo'
import activityVideoDetail from '@/views/activity/activityVideoDetail'
import test from '@/views/testP/test'
import testInfo from '@/views/testP/testInfo'
import testResult from '@/views/testP/testResult'
import testAnalysis from '@/views/testP/testAnalysis'

import error404 from '@/views/error/404'

Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/publicVideo',
    name: 'publicVideo',
    component: publicVideo
  },
   {
    path: '/departmentVideo',
    name: 'departmentVideo',
    component: departmentVideo
  },
  {
    path: '/activityVideo',
    name: 'activityVideo',
    component: activityVideo
  },
  {
    path: '/training',
    name: 'training',
    component: training
  },
  {
    path: '/trainingMaterials',
    name: 'trainingMaterials',
    component: trainingMaterials
  },
  {
    path: '/trainingPlanGuide',
    name: 'trainingPlanGuide',
    component: trainingPlanGuide
  },
  {
    path: '/test',
    name: 'test',
    component: test
  },
  {
    path: '/testInfo',
    name: 'testInfo',
    component: testInfo
  },
  {
    path: '/testResult',
    name: 'testResult',
    component: testResult
  },
  {
    path: '/testAnalysis',
    name: 'testAnalysis',
    component: testAnalysis
  },
  {
    path: '/activityVideoDetail/:id',
    name: 'activityVideoDetail',
    component: activityVideoDetail
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/register',
    name: 'register',
    component: register
  },
  {
    path: '/teacherRegister',
    name: 'teacherRegister',
    component: teacherRegister
  },
  {
    path: '/center',
    component: center,
    children: [
      {
        path: '',
        redirect: '/center/profile'
      },
      {
        path: 'profile',
        name: 'profile',
        component: profile
      },
      {
        path: 'study',
        name: 'study',
        component: study
      },
      {
        path: 'watch',
        name: 'watch',
        component: watch
      },
      {
        path: 'note',
        name: 'note',
        component: note
      },
      {
        path: 'clock',
        name: 'clock',
        component: clock
      },
      {
        path: 'tasks',
        name: 'tasks',
        redirect: to => ({
          path: '/trainingPlanGuide',
          query: to.query
        })
      },
      {
        path: 'messages',
        name: 'messages',
        component: messages
      }
    ]
  },
  {
    path: '/videoList',
    name: 'videoList',
    component: videoList
  },
  {
    path: '/videoPlay',
    name: 'videoPlay',
    component: videoPlay
  },
  {
    path: '/404',
    name: '404',
    component: error404,
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/404'
 },

]

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'hash',  // 改为 hash 模式，无需服务器特殊配置
  routes
})

export default router
